<template lang='pug'>
  #GPT(style='max-height: calc(100vh);').main-page.GPT-color.page-noScroll.pb-0.position-relative
    loadingOverlay(v-show='loading' message='Loading . . .' :zIndex='999')
    // 標題行
    div.d-flex.align-center.px-0.pb-0.px-md-2.pb-md-4(cols='4' md='6' )
      span.ml-4.mr-6(style='font-weight: 700; font-size: 28px;') {{$t('GPT_MENU.GROUP_MANAGEMENT')}}
      v-btn.white--text(@click='showAddDialog' height='40' :ripple='false' color='#14C6DE' depressed)
        v-img.mr-1(src="../assets/images/add-white-thin.png" max-height="16" max-width="16")
        span(style='font-weight: 700; font-size: 16px;') {{$t("MANAGEGROUPS.ADD_GPT_GROUP")}}
    // 篩選搜尋區
    div.ma-0.mt-3.pa-0.d-flex.align-center.justify-space-between
      v-row.ma-0.pa-0.d-flex.justify-start
        // 團隊篩選
        v-col(cols='2' width='100px').px-0.ml-6
          div(style="position: absolute; margin-top:-22px; font-family: 'Segoe UI'; font-weight: 400; font-size: 12px; color: #444444;") {{$t('MANAGEGROUPS.GROUP')}}
          v-select.bg-white(v-model='selectGroup' height='30' dense outlined clearable :placeholder='$t("MANAGEGROUPS.GROUP")' :items='all_group_list' item-value='id' item-text='name')
        //- // 成員篩選
        //- v-col(cols='2').px-0.ml-2
        //-   div(style="position: absolute; margin-top:-22px; font-family: 'Segoe UI'; font-weight: 400; font-size: 12px; color: #444444;") {{$t('MANAGEGROUPS.MEMBER')}}
        //-   v-select.bg-white.my-chips-select(v-model='selected_users' height='30' multiple my-chip dense chips outlined clearable :placeholder='$t("MANAGEGROUPS.MEMBER")' :items='user_list' item-value='id' item-text='name')
        //-     template(v-slot:selection="{ item, index }")
        //-       v-chip(v-if="index === 0")
        //-         span {{ item.name }}
        //-       span(v-if="index === 1" class="grey--text text-caption" style="font-size: 8px;") +{{ selected_users.length - 1 }}
        // 啟動篩選按鈕
        v-col(cols='1').px-0.ml-3.mr-1
          v-btn.white--text(@click='act_search' height='40' :ripple='false' color='#14C6DE' depressed)
            v-img.mr-1(src="../assets/images/search_btn_icon.png" max-height="18" max-width="18")
            span(style='font-weight: 600; font-size: 16px;') {{$t('GENERAL.SEARCH')}}
        // 重置選擇按鈕
        v-col(cols='1').px-0.ml-0
          v-btn(text height='40' @click='refresh')
            v-img.mr-1(src="../assets/images/refresh.png" max-height="16" max-width="16")
            span(style="font-family: 'Segoe UI'; font-weight: 700; font-size: 16px; color: #14C6DE;") {{$t('GENERAL.REFRESH')}}
        // 關鍵字搜尋 
        v-col(cols='1').px-0.ml-1
          div.lib_search_bar_style
            v-text-field(v-model='group_N_member_search' flat dense append-icon='icon-search' rounded outlined style='width:200px;' hide-details)
    // 團隊列表區 (主要區域)
    #page-inner.scroll-x(style='max-height: calc(85vh) !important;')
      v-card.ml-6.mb-2.scrollbar.rounded-card.groupdata-card(v-if='!loading')
        v-container.pa-0.ma-0.grouppage-container()
          v-data-table.dashboard-table.mx-5(
            multi-sort
            :headers='manageGroupHeaders' 
            :header-props="{sortIcon: 'mdi mdi-arrow-up'}",
            :items='upgpt_group_list' 
            item-class="dataTableColor"
            :items-per-page='itemPerPage' 
            :page.sync='page' 
            fixed-header 
            @page-count='pageCount = $event' 
            :search='group_N_member_search'  
            hide-default-footer, 
            dense
          )
            template(v-slot:item.name='{ item }')
                .ellipsis
                    span(:title='item.name') {{ item.name }}
            template(v-slot:item.user_name_string='{ item }')
                .ellipsis
                    span(:title='item.user_name_string') {{ item.user_name_string }}    
            template(v-slot:item.active='{ item }')
                v-btn(icon @click='showEditDialog(item)')
                    v-icon(size='20') mdi-square-edit-outline
                v-btn(icon @click='onDelete(item)')
                    v-icon(size='18') icon-remove
          v-pagination.py-1.mb-3(v-model='page' :length='pageCount' circle :total-visible="10")
    
    v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitMessageDialog(false)' @keydown.enter='onEmitMessageDialog(true)')
      message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
    v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog(true)')
      success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
    v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
      error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
    v-dialog(v-model='addDialog' width='480' content-class='statusDialog' v-if='addDialog')
      add-dialog(@emitAddDialog='onEmitAddDialog')
    v-dialog(v-model='editDialog' width='480' content-class='statusDialog' v-if='editDialog')
      edit-dialog(:editdata='edit_group_data' @emitEditDialog='onEmitEditDialog')
    
</template>
<script>
import i18n from '/common/plugins/vue-i18n.js';
import loadingOverlay from "@/components/Common/loadingOverlay";
import messageDialog from "@/components/Dialog/messageDialog";
import successDialog from "@/components/Dialog/successDialog";
import errorDialog from "@/components/Dialog/errorDialog";
import addDialog from "@/components/GPT_Dialog/ManageGroups/addGroup";
import editDialog from "@/components/GPT_Dialog/ManageGroups/editGroup";
import PermissionService from "@/services/PermissionService";
// import PersonalSettingService from "@/services/PersonalSettingService"; // 不需要成員篩選
import permissionTypeList from "@/array/the_GPTpermissionTypeList";

export default {
  components: {
    loadingOverlay,
    messageDialog,
    successDialog,
    errorDialog,
    addDialog,
    editDialog,
  },
  data() {
    return {
      // Other
      loading: false,
      // Dialog
      messageDialog: false,
      message: "",
      successDialog: false,
      successMessage: "",
      errorDialog: false,
      errorMessage: "",
      addDialog: false,
      editDialog: false,
      // Filter
      selectGroup: null,
      all_group_list: [],
      // selected_users: [], // 不需要成員篩選
      // user_list:[], // 不需要成員篩選
      group_N_member_search:'',
      // Data
      upgpt_group_list: [],
      permissionTypeList: permissionTypeList,
      manageGroupHeaders: [
          {text: i18n.t('MANAGEGROUPS.NAME'), value: 'name', align: 'left',width:'30%', class: ""},
          {text: i18n.t('MANAGEGROUPS.MEMBER'), value: 'user_name_string', align: 'left',width:'60%', class: "", sortable: false},
          {text: i18n.t('MANAGEGROUPS.ACTIVE'), value: 'active', align: 'center',width:'10%', class: "", sortable: false},
      ],
      itemPerPage: 12,
      page: 1,
      pageCount: 0,
      deleteGroupID: null,
      edit_group_data: {},
    };
  },
  async created() {
    this.loading = true;
    await this.getUpGPTGroupListData();
    // await this.getUserListData(); // 不需要成員篩選
    this.loading = false;
  },
  methods: {
    async getUpGPTGroupListData(){
      this.deleteGroupID - null;
      this.edit_group_data = {};
      await PermissionService.getGroups().then(response => {   
        if (response.data.length > 0) {
          let temp_datas = response.data;
          this.upgpt_group_list = [];
          for(let index in temp_datas){
            if(temp_datas[index]['permission_type'] == "UPGPT"){
              this.upgpt_group_list.push(temp_datas[index])
            }
          }
        }
        this.getPermissionTypeDisplay();
        this.getUsernameStringDisplay();
        this.all_group_list = [];
        for(let index in this.upgpt_group_list){
          this.all_group_list.push(this.upgpt_group_list[index])
        }
      }).catch((response) => {
        this.showErrorDialog(response);
      });
    },
    getPermissionTypeDisplay() {
      this.upgpt_group_list = this.upgpt_group_list.map(g => ({ ...g, 
        permission_type_name: this.getItemNameFromList(this.permissionTypeList, g.permission_type) 
      }));
    },
    userObjtoString(user_obj_list) {
      let user_name_string = "";
      for(let index in user_obj_list){
        user_name_string += `${user_obj_list[index]['last_name']} ${user_obj_list[index]['first_name']}、`
      }
      user_name_string = user_name_string.slice(0, -1);
      return user_name_string
    },
    getUsernameStringDisplay() {
      this.upgpt_group_list = this.upgpt_group_list.map(g => ({ ...g, 
        user_name_string: this.userObjtoString(g.user_set) 
      }));
    },
    // Dialog Area ----------------------------------------- [Start]
    showAddDialog() {
      this.addDialog = true;
    },
    onEmitAddDialog(val){
      if(val){
        this.showSuccessDialog();
        this.act_search();
      }
      this.addDialog = false;
    },
    showEditDialog(target) {
      this.edit_group_data = target
      this.editDialog = true;
    },
    onEmitEditDialog(val){
      if(val){
        this.showSuccessDialog();
        this.act_search();
      }
      this.edit_group_data = {};
      this.editDialog = false;
    },
    showSuccessDialog() {
      this.successDialog = true;
    },
    onEmitSuccessDialog() {
      this.successDialog = false;
    },
    showErrorDialog(message) {
      this.errorDialog = true;
      this.errorMessage = message;
    },
    onEmitErrorDialog() {
      this.errorDialog = false;
    },
    showMessageDialog(message) {
      this.messageDialog = true;
      this.message = message;
    },
    async onEmitMessageDialog(val) {
      this.messageDialog = false;
      if(val){
        PermissionService.deleteGroup(this.deleteGroupID).then(()=> {
          this.deleteGroupID = null;
          this.showSuccessDialog();
          this.act_search();
        }).catch((response) => {
          this.deleteGroupID = null;
          this.showErrorDialog(response.data);
        });
      }
    },
    // Dialog Area ----------------------------------------- [End]
    async act_search() {
      await this.getUpGPTGroupListData();
      let temp_arr = []
      this.upgpt_group_list.filter(el => {
        if(this.selectGroup == null){
          if((el.name.includes(this.group_N_member_search)) || (el.user_name_string.includes(this.group_N_member_search))){
            temp_arr.push(el);
          }
        }else{
          if(((el.name.includes(this.group_N_member_search)) || (el.user_name_string.includes(this.group_N_member_search))) && (el.id == this.selectGroup)){
            temp_arr.push(el);
          }
        }
      });
      this.upgpt_group_list = temp_arr
    },
    async refresh(){
      this.selectGroup = null;
      // this.selected_users = [];  // 不需要成員篩選
      this.group_N_member_search = '';
      await this.getUpGPTGroupListData();
    },
    onDelete(item) {
      this.showMessageDialog(i18n.t('MANAGEGROUPS.MESSAGE'));
      this.deleteGroupID = item.id;
    },
  },
  watch:{
    "group_N_member_search":function(){
      this.act_search();
    },
  }
};
</script>
<style scoped>
.groupdata-card {
  max-height: calc(79vh) !important;
  max-width: calc(80vw) !important;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2) !important;
}
.grouppage-container {
  width: 100% !important;
  max-width: 100vw !important;
}
</style>